export default "__VITE_ASSET__bJr4J0b3__"